<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The author graduated in medicine from the Federal University of Pelotas in 1989. She dedicated two years of medical practice as GP. In the next three years, she decided to study Freudian psychoanalysis. Since 1994, she is recognized as a specialist by the Brazilian Association of Psychiatry and Latin American Association of Psychiatry. Her studies on the properties of psychic energy began around 1998. During this period, she developed meditative techniques, using drawings to achieve expanded states of consciousness, through which she gained access to the contents of this book. After acting in her own clinic and having passed the public service, the author withdrew to complete her books. Two books were released in Brazil and this is the first one in English. The book goes beyond psychiatric and psychoanalytic knowledge and contends philosophical and spiritual views of human psychic energy.</p>
<p>Although the author’s writing is based mainly on scientific elements and medical experiences, the writing process included moments of channeling. This is why she asserts that life after death is a postulate of consciousness.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?733e5b33